
<div class="modal-header">
    <h4 class="modal-title pull-left">Rot Parser</h4>
    <div aria-label="Close" (click)="onCancel()" class="close pull-right">
        <span aria-hidden="true">×</span>
    </div>
</div>

<div class="modal-body upload-file">
    <loader [loading]="loading"></loader>
    <!-- Success Message -->
    <div *ngIf="isSuccess" class="alert alert-success">
        File processed successfully!
    </div>
    <!-- Error Message -->
    <div *ngIf="isError" class="alert alert-danger">
        {{ errorMessage }}
    </div>
    <ngx-file-drop *ngIf="!isSuccess && !loading" dropZoneLabel="Drop files here" (onFileDrop)="fileDropped($event)"
        multiple="false" dropZoneLabel="Drag & Drop File">
        <ng-template ngx-file-drop-content-tmp let-openFileSelector="openFileSelector">
            <a class="pick-file" (click)="openFileSelector()">
                <div class="d-block">
                    <div class="text-center">Drag & Drop File here</div>
                    <div class="text-center">Or Pick by Clicking</div>
                </div>
            </a>
        </ng-template>
    </ngx-file-drop>

</div>

<div class="modal-footer">
    <button type="button" class="btn btn-rbv default" (click)="onCancel()">Cancel</button>
</div>
